import React, { useState } from 'react';
import { useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DSBox from '../../../design-system/DSBox';
import DSTypography from '../../../design-system/Typography/DSTypography';
import DSAccordion from '../../../design-system/DSAccordion';
import DSAccordionSummary from '../../../design-system/DSAccordionSummary';
import DSAccordionDetails from '../../../design-system/DSAccordionDetails';
import LinkedText, { TextLink } from './LinkedText';

type FAQItem = {
  question: string;
  answer: string;
  links?: TextLink[];
};

type FAQAccordionProps = {
  faqs: FAQItem[];
};

const FAQAccordion = ({ faqs }: FAQAccordionProps) => {
  const { palette, spacing } = useTheme();
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <DSBox
      sx={{
        background: 'transparent',
        borderRadius: spacing(2),
        overflow: 'hidden',
      }}
    >
      {faqs.map((faq, index) => (
        <DSBox key={index}>
          <DSAccordion
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
            sx={{ backgroundImage: 'none' }}
          >
            <DSAccordionSummary
              expandIcon={
                <ExpandMoreIcon sx={{ color: palette.text.primary }} />
              }
            >
              <DSTypography variant="value" color={palette.text.primary}>
                {faq.question}
              </DSTypography>
            </DSAccordionSummary>
            <DSAccordionDetails>
              <DSTypography variant="body1" color={palette.text.secondary}>
                <LinkedText text={faq.answer} links={faq.links} />
              </DSTypography>
            </DSAccordionDetails>
          </DSAccordion>
        </DSBox>
      ))}
    </DSBox>
  );
};

export default FAQAccordion;
export type { FAQItem };
